import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=bc64b818&scoped=true&"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrUpdate.vue?vue&type=style&index=0&id=bc64b818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc64b818",
  null
  
)

export default component.exports